// @flow
import React from 'react';
import css from './profile-picture.css';
type Props = {
  person: Object,

}
class ProfilePicture extends React.Component<Props> {
  render() {
    const style = {
      backgroundImage: `url(${this.props.person.profilePicture})`
    }

    const initials = this.props.person && this.props.person.firstname && this.props.person.lastname ?
      this.props.person.firstname[0] + this.props.person.lastname[0] : null;

    return <div className={css.profilePicture} style={style}>
      <div className={css.initials}>
        {initials}
      </div>
    </div>
  }
}

export default ProfilePicture